import script from "./chart-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./chart-bar.vue?vue&type=script&setup=true&lang=ts"

import "./chart-bar.vue?vue&type=style&index=0&id=61480cd9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61480cd9"]])

export default __exports__